import { React } from "react";
import { useParams } from "react-router-dom";
const Componente = ({ rutasurl }) => {
    const { "*": dynamicPath } = useParams(); // Captura la ruta después de "component/"
    // Buscar la ruta correspondiente en rutasurl
    const rutaEncontrada = rutasurl.find((ruta) => ruta.nombre === dynamicPath);
    
    // Si no se encuentra la ruta, mostrar un mensaje de error
    if (!rutaEncontrada) {
      return(<div className="flex justify-center items-center w-full h-full bg-white">
        <h2 className="text-center text-red-500 text-[2rem] ">Error 404: Página {dynamicPath} no encontrada</h2>
      </div> 
      );
    }  
    
    return (
      <div className="w-full h-full">
        <iframe
          title={dynamicPath}
          className="w-full h-full border-0"
          src={rutaEncontrada.url} // Usa la URL correcta de la ruta encontrada
          allowFullScreen
          sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        ></iframe>
      </div>
    );
  };
export default Componente;